// -------------------------------------
//  Clickable
// -------------------------------------
export default function Clickable(mySelector){
  $(mySelector).each(function(){
    const t = $(this);
    const a = t.find('a');
    const href = a.attr('href');
    t.on('click', function(e){
      e.preventDefault();
      if (a.attr('target') == '_blank') {
        window.open(href);
      } else {
        location.href = href;
      }
    });
  });
}
